import { useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import CustomizeSubtopicModal from "./CustomizeSubtopicModal";

const DEFAULT_TOPICS = [
  {
    subtopic_id: 1,
    subtopic_name: "Torque & Equilibrium",
    subtopic_level: "Hard Mastery",
  },
];

const CustomizeSubtopicPage = () => {
  const history = useHistory();
  const location = useLocation();

  const topics = useMemo(() => {
    const routeTopics = location.state?.topics;
    return Array.isArray(routeTopics) && routeTopics.length
      ? routeTopics
      : DEFAULT_TOPICS;
  }, [location.state]);

  const initialTopicId = location.state?.initialTopicId || topics?.[0]?.subtopic_id;
  const initialDifficulty = location.state?.initialDifficulty || "Hard";

  const handleClose = () => {
    history.goBack();
  };

  const handleSave = (payload) => {
    if (typeof location.state?.onSave === "function") {
      location.state.onSave(payload);
    }
    history.goBack();
  };

  return (
    <CustomizeSubtopicModal
      isOpen
      onClose={handleClose}
      onSave={handleSave}
      topics={topics}
      initialTopicId={initialTopicId}
      initialDifficulty={initialDifficulty}
    />
  );
};

export default CustomizeSubtopicPage;
